import styled from "styled-components";
export const PackageBookingFrontEndWrapper = styled.div`
  background-color: #f6f8f9;
  padding: 40px 20px;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .package-booking-expiration-timer {
    align-items: center;
    background: #fffbe6;
    border: 1px solid #ffe58f;
    border-radius: 6px;
    color: #594214;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    padding: 12px 16px;

    span {
      color: #ad6800;
      font-size: 18px;
      font-variant-numeric: tabular-nums;
      font-weight: 700;
      margin-left: 12px;
    }
  }
  .package-booking-expired {
    align-items: center;
    background: #fff;
    display: flex;
    inset: 0;
    justify-content: center;
    position: absolute;

    h1 {
      color: #22335d;
      font-size: 24px;
      margin: 0;
    }
  }
  .package-view-frontend {
    &-body {
      display: flex;
      margin: auto;
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
    }
    &-left {
      overflow-y: auto;
      flex: 1;
      padding: 30px;
      @media only screen and (max-width: 600px) {
        padding: 0px;
      }
    }
    &-right {
      background-color: #fff;
      box-shadow: 0 1px 4px rgb(64 87 109 / 7%);
      padding: 20px;
      width: 400px;
      display: flex;
      flex-direction: column;
      transform: translateX(0);
      transition: all 0.35s ease;
      @media only screen and (max-width: 1200px) {
        position: absolute;
        z-index: 100;
        top: 0;
        right: 0;
        bottom: 0;
      }
      @media only screen and (max-width: 600px) {
        width: 100%;
      }
    }
    &-booking-details {
      background-color: #fff;
      position: absolute;
      bottom: 0;
      padding: 20px;
      left: 0;
      right: 0;
      box-shadow: 0 1px 4px rgb(64 87 109 / 7%);
      z-index: 80;
      &-btn {
        background-color: #1d3bf8;
        height: 50px;
        width: 100%;
        color: #fff;
        font-size: 18px;
        font-family: "Avenir";
        font-weight: 900;
      }
    }
  }
  .hide {
    transform: translateX(100%);
    width: 0;
  }
`;

export const BookingContactInformationWrapper = styled.div`
  margin-bottom: 40px;
  background-color: #fff;
  box-shadow: 0 1px 4px rgb(64 87 109 / 7%);
  padding: 40px 25px;
  .booking-contact {
    &-title {
      color: #22335d;
      font-size: 18px;
      font-weight: 900;
      font-family: "Avenir";
    }
    &-des {
      color: #485b7c;
      font-size: 16px;
      font-weight: 300;
      font-family: "Avenir";
    }
  }
`;
